module.exports = __webpack_public_path__ + "f6d7ab53fbd5a772524ea8b16cbac142.png";